import React, { useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import {uuid} from 'uuidv4';
import ipfs from 'decentralized/Ipfs.js';
import ImageHandler from './ImageHandler.js';
import {setProjectDragging} from 'actions/index.js';
import {setExploreUnpublished} from 'actions/index.js';
import {connect} from 'react-redux';

const EditList = ({hide, projectDragging, setProjectDragging, list, setExploreUnpublished, onDelete}) => { 
    const [name, setName] = useState('');
    const [projects, setProjects] = useState([]);
    const [imageHash, setImageHash] = useState(undefined);
    const [trackDragging, setTrackDragging] = useState(undefined);

    useEffect(() => {
        if (list) {
            setProjects(list.projects);
            setName(list.name);
            setImageHash(list.image);
        }
    }, [list]);

    const onDrop = useCallback((e) => {
        if (projectDragging) {
            setProjects([... projects, projectDragging]);
            setProjectDragging(undefined);
        }
    }, [projectDragging, projects, setProjects]);

    const onOrderChangeDrop = useCallback((destinationTrack) => {
        if (!trackDragging) {
            return;
        }

        let from = projects.indexOf(trackDragging);
        let _projects = [... projects];
        _projects.splice(from, 1);
        let to = _projects.indexOf(destinationTrack);
        _projects = [
            ... _projects.slice(0, to),
            trackDragging,
            ... _projects.slice(to)
        ];
        setTrackDragging(undefined);
        setProjects(_projects);
    }, [trackDragging, setProjects, projects, setTrackDragging]); 

    const deleteProject = useCallback((project) => {
        let index = projects.indexOf(project);
        let _projects = [... projects];
        _projects.splice(index, 1);
        setProjects(_projects);
    }, [projects, setProjects]);

    const onSave = useCallback(async () => {
        let json = {
            name,
            title: name,
            projects,
            image: imageHash,
            id: uuid()
        };
        if (list) {
            json.hash = list.newContent;
            json.newContent = list.newContent;
        }
        let lists = lstorage.getItem("unsavedLists");
        if (lists) {
            lists = JSON.parse(lists);
        } else {
            lists = [];
        }
        if (list && lists.length > 0) {
            // then replace
            for (let i in lists) {
                let _list = lists[i];
                if (_list.name === list.name || (list.hash && _list.hash === list.hash)) {
                    lists[i] = json;
                    break;
                }
            }
        } else {
            lists.push(json);
        }
        let unpublishedChanges = JSON.stringify(lists);
        lstorage.setItem("unsavedLists", unpublishedChanges);
        setExploreUnpublished(lists);
        hide(json);
    }, [name, projects, imageHash, hide, list]);

    return (
        <div
          className="new-list">
          <div
            onDrop={onDrop}
            onDragOver={(e) => e.preventDefault()}
            className="inner">
            <input
              placeholder="Type name for list"
              value={name}
              onChange={e => setName(e.target.value)}
              type="text"/>
            <div className="projects">
              {projects.map(
                  x =>
                      <div
                        key={x.newSequence}
                        onDrop={() => onOrderChangeDrop(x)}
                        onDragOver={(e) => e.preventDefault()}
                        onDragStart={() => setTrackDragging(x)}
                        draggable={true}
                        className="project">
                        <div className="project-name">{x.title}</div>
                        <div onClick={() => deleteProject(x)} className="delete-btn">x</div>
                      </div>)}
            </div>
            <div
              className="drop-here">
              <span>
                Drop projects here
              </span>
            </div>
            <div className="btns">
              <div onClick={onSave} className="done-btn">
                Done
              </div>
              <div onClick={() => hide()} className="cancel-btn">
                Cancel 
              </div>
           </div>
          </div>
          <div className="inner">
            <ImageHandler imageHash={imageHash} setImageHash={setImageHash}/>
            {list ?
             <div onClick={() => {
                 if (window.confirm("Confirm delete")) onDelete();
             }} className="delete-list-btn">
               Delete List
             </div> : ''}
 
         </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      projectDragging: state.explore.projectDragging
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setProjectDragging: (x) => dispatch(setProjectDragging(x)),
      setExploreUnpublished: (x) => dispatch(setExploreUnpublished(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditList);
